export const RE_SIZING_PLYWOOD_HISTORY_REQUEST = "RE_SIZING_PLYWOOD_HISTORY_REQUEST";
export const RE_SIZING_PLYWOOD_HISTORY_SUCCESS = "RE_SIZING_PLYWOOD_HISTORY_SUCCESS";
export const RE_SIZING_PLYWOOD_HISTORY_FAILED = "RE_SIZING_PLYWOOD_HISTORY_FAILED";